import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import Select from 'react-select';

const NatureOfSuitField = ({ districtNosOptions }) => {
  return (
    <Field name="nature_of_suit" parse={values => values.map(({ value }) => value)}>
      {({ input }) => (
        <Fragment>
          <label>Nature of Suit</label>
          <Select {...input} multi options={districtNosOptions} className="form-select" />
        </Fragment>
      )}
    </Field>
  );
};

NatureOfSuitField.propTypes = {
  districtNosOptions: PropTypes.array.isRequired,
};

export default NatureOfSuitField;



// WEBPACK FOOTER //
// ./src/components/advancedSearch/fields/NatureOfSuit.jsx